var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lmp-block clearBoth"},_vm._l((_vm.data.horizontal),function(d,i){return _c('g-switch-list3',{key:'h' + i,attrs:{"chip":_vm.chip,"title":d.title,"columns":2,"current":_vm.current,"list":d.list}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c89f2e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageComponents/lh/zongxiao.vue
// module id = null
// module chunks = 